import _ from 'lodash';
import { createSelector } from 'reselect';

import {
  get,
  post,
  put,
  del, } from 'utils/fetch';
import { createListSelector } from 'utils/list';


import { RequestState } from 'constants/constants';
import { selectCurrentAccountId } from 'store/AppState';


export const FETCH_CHANNEL = 'FETCH_CHANNEL';
export const FETCH_CHANNELS = 'FETCH_ACCOUNT_CHANNELS';
export const ADD_TWITCH_CHANNELS = 'ADD_TWITCH_CHANNELS';
export const ADD_YOUTUBE_CHANNELS = 'ADD_YOUTUBE_CHANNELS';
export const REMOVE_CHANNEL = 'REMOVE_CHANNEL';
export const UPDATE_CHANNEL_SETTINGS = 'UPDATE_CHANNEL_SETTINGS';




export const selectChannels = (state) => state.models.channels;
export const selectChannel = (state, channelId) => state.models.channels[channelId];
export const selectChannelsByIds = (state, ids) => createSelector(
  selectChannels,
  (channels) => _.pick(channels, ids)
)(state);
export const selectChannelsByAccount = createListSelector('channelsByAccount');


export const twitchUrl = channel => `https://twitch.tv/${channel?.serviceName}`;
export const youtubeUrl = channel => `https://youtube.com/channel/${channel?.serviceId}`;

const ChannelModel = {
  actions: {

    fetchChannel: channelId => dispatch => get({
      url: "/api/channel/:channelId", 
      params: { channelId },
      dispatch, 
      action: FETCH_CHANNEL,
    }),

    fetchChannels: (accountId) => (dispatch, getState) => {
      accountId = accountId ?? selectCurrentAccountId(getState());
      return get({
        url: '/api/account/:accountId/channels',
        params: { accountId },
        dispatch,
        action: FETCH_CHANNELS,
      })
    },

    addTwitchChannels: serviceIds => (dispatch, getState) => {
      let accountId = selectCurrentAccountId(getState());
      serviceIds = _.castArray(serviceIds);
      return put({
        url: "/api/account/:accountId/channels/twitch",
        params: { accountId },
        body: { serviceIds },
        dispatch,
        action: ADD_TWITCH_CHANNELS,
      });
    },

    addYouTubeChannels: serviceIds => (dispatch, getState) => {
      let accountId = selectCurrentAccountId(getState());
      serviceIds = _.castArray(serviceIds);
      return put({
        url: "/api/account/:accountId/channels/youtube",
        params: { accountId },
        body: { serviceIds },
        dispatch,
        action: ADD_YOUTUBE_CHANNELS,
      });
    },

    updateChannelSettings: (channelId, settings) => (dispatch, getState) => {
      let accountId = selectCurrentAccountId(getState());
      return put({
        url: '/api/account/:accountId/channel/:channelId/settings',
        params: { accountId, channelId },
        body: { settings },
        dispatch,
        action: UPDATE_CHANNEL_SETTINGS,
      });
    },

    removeChannel: channelId => (dispatch, getState) => {
      let accountId = selectCurrentAccountId(getState());
      return del({
        url: "/api/account/:accountId/channel/:channelId",
        params: { accountId, channelId },
        dispatch,
        action: REMOVE_CHANNEL,
      });
    },
  },

  spec: {
    channels: {},
  },

  reducer: (state, type, body, action, json) => {
    if (action.url && action.result !== RequestState.SUCCESS) 
      return state;

    if(body && body.channels) {
      return { ...state, 
        channels: { ...state.channels, 
          ..._.keyBy(body.channels, '_id'),
        } 
      }
    }

    switch(type) {
      case REMOVE_CHANNEL: {
        return {
          ...state,
          channels: _.omit(state.channels, action.params.channelId),
        }
      }
          
    }
    return state;
  },
}

export default ChannelModel;
